export enum CookieName {
    SearchCriteria = 'searchCriteria',
}
